import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APIRoutes } from '../global-misc/api-routes';
import { firstValueFrom } from 'rxjs';
import { CalculatePremoResponseModel } from '../global-data-models/premo.model';
import { VisitService } from './visit.service';

@Injectable({ providedIn: 'root' })
export class PremoService {
  constructor(
    private readonly http: HttpClient,
    private readonly visitService: VisitService
  ) { }

  public async canCalculatePremo(orgId: string, patientId: string): Promise<boolean> {
    const numVisits: number = (await this.visitService.getPatientVisits(orgId, patientId)).length;
    return numVisits > 0;
  }

  async calculatePremo(orgId: string, patientId: string): Promise<CalculatePremoResponseModel> {
    const apiRoute = APIRoutes.CALCULATE_PREMO_ROUTE.replace(":orgId", orgId).replace(":patientId", patientId);
    return await firstValueFrom(this.http.get<CalculatePremoResponseModel>(apiRoute));
  }
}
